import React, { useState } from 'react';
import { HStack } from '@chakra-ui/react';
import { useColors } from '../../../../components/common/Color';
import HeaderSection from '../../../../components/common/Header/HeaderSection';
import PassBookTable from './PassBookTable';

function PassBook() {
  const colors = useColors();


  return (
    <div>
      {/* Use the new HeaderSection component */}
      <HeaderSection
        title="Pass Book" 
        breadcrumb={["Dashboard", "Accounts", "Pass Book"]} 
      />

      <HStack align="start" w='100%' gap="0" mt={4} p={6}>
        <PassBookTable colors={colors} />

      </HStack>
    </div>
  );
}

export default PassBook;
